// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

const fieldStyle = sx(
  `width:100%;height:40px;padding:0 13px;border:1px solid #C8D4EA;border-radius:8px;background:#fff;font-family:inherit;font-size:13px;color:var(--ink);outline:none;box-sizing:border-box`
);

const labelStyle = sx(
  `display:block;font-size:11px;font-weight:500;letter-spacing:0.08em;text-transform:uppercase;color:rgba(255,255,255,.40);margin-bottom:7px`
);

export default function CreateVersionModal({ vm }: { vm: any }) {
  if (!vm.createOpen) return null;

  return (
    <div
      data-testid="gm-create-version"
      onClick={vm.closeCreate}
      style={sx(
        `position:fixed;inset:0;z-index:60;background:rgba(8,35,76,0.45);display:flex;align-items:center;justify-content:center;padding:24px`
      )}
    >
      <div
        onClick={vm.stopClose}
        style={sx(
          `width:100%;max-width:380px;max-height:calc(100vh - 48px);overflow:auto;border-radius:24px;box-shadow:0 30px 60px -25px rgba(8,35,76,0.5)`
        )}
      >
        <div
          style={sx(
            `width:100%;background:var(--navy);border-radius:24px;padding:22px;color:rgba(255,255,255,.78);position:relative;overflow:hidden`
          )}
        >
          <div style={sx(`position:relative`)}>
            <div style={sx(`display:flex;align-items:center;gap:10px`)}>
              <div
                style={sx(
                  `flex:1;min-width:0;font-size:11px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:rgba(255,255,255,.40)`
                )}
              >
                Create new version
              </div>
              <button
                className="gmHover"
                onClick={vm.closeCreate}
                style={sx(
                  `flex:none;width:26px;height:26px;display:flex;align-items:center;justify-content:center;border:1px solid rgba(255,255,255,.24);border-radius:999px;background:transparent;color:#fff;font-family:inherit;font-size:13px;line-height:1;cursor:pointer`
                )}
                data-hover="background:rgba(255,255,255,0.10)"
              >
                ×
              </button>
            </div>
            <div style={sx(`font-size:20px;font-weight:600;color:#fff;letter-spacing:-0.03em;margin:6px 0 18px`)}>
              From {vm.createSourceName}
            </div>
            <label style={sx(`display:block`)}>
              <span style={labelStyle}>Working version name</span>
              <input
                className="gmFocus"
                autoFocus
                value={vm.createName}
                onChange={vm.creating ? undefined : vm.onCreateName}
                onClick={vm.stopClose}
                disabled={!!vm.creating}
                style={fieldStyle}
              />
            </label>
            <label style={sx(`display:block;margin-top:14px`)}>
              <span style={labelStyle}>Actuals cutoff</span>
              <select
                className="gmFocus"
                value={vm.createCutoff}
                onChange={vm.creating ? undefined : vm.onCreateCutoff}
                onClick={vm.stopClose}
                disabled={!!vm.creating}
                style={fieldStyle}
              >
                {(vm.createCutoffOpts || []).map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </label>
            <button
              onClick={vm.createReady ? vm.doCreateVersion : undefined}
              disabled={!vm.createReady}
              style={sx(
                `width:100%;height:42px;margin-top:16px;border:none;border-radius:999px;font-family:inherit;font-size:13px;font-weight:500;cursor:${vm.creating ? 'wait' : vm.createReady ? 'pointer' : 'not-allowed'};background:${vm.createReady || vm.creating ? '#0052CD' : 'rgba(255,255,255,0.10)'};color:${vm.createReady || vm.creating ? '#fff' : 'rgba(255,255,255,0.40)'}`
              )}
            >
              {vm.createLabel}
            </button>
            <p style={sx(`font-size:11.5px;color:rgba(255,255,255,.40);margin:12px 0 0;line-height:1.5`)}>
              Copies inputs, drivers, settings, rules and scenarios into a separate working version. {vm.createSourceName} stays locked and Forecast working is not changed.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
